export default __webpack_public_path__ + "static/media/ibm.94936cbe.svg";